var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsersRound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9974 17.5C14.9974 15.7319 14.295 14.0362 13.0448 12.786C11.7945 11.5357 10.0988 10.8333 8.33073 10.8333M8.33073 10.8333C6.56262 10.8333 4.86693 11.5357 3.61668 12.786C2.36644 14.0362 1.66406 15.7319 1.66406 17.5M8.33073 10.8333C10.6319 10.8333 12.4974 8.96785 12.4974 6.66667C12.4974 4.36548 10.6319 2.5 8.33073 2.5C6.02954 2.5 4.16406 4.36548 4.16406 6.66667C4.16406 8.96785 6.02954 10.8333 8.33073 10.8333ZM18.3308 16.6666C18.3308 13.8583 16.6641 11.25 14.9974 9.99996C15.5453 9.58893 15.9834 9.0492 16.2729 8.42852C16.5625 7.80784 16.6945 7.12535 16.6575 6.44146C16.6204 5.75757 16.4153 5.09336 16.0603 4.50763C15.7054 3.92189 15.2115 3.43268 14.6224 3.08329",
    stroke: "#EA580C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersRound);
export default __webpack_public_path__ + "static/media/UsersRound.5f16efc0001a4447f8093fa04909c417.svg";
export { ForwardRef as ReactComponent };